<div id="vue">
  <el-container>
    <router-view />
  </el-container>
</div>
